/**
 * Пауза рассылки после ограничения Telegram: бейдж под статусом и иконка у лимита.
 */
import { Pause } from 'lucide-react';
import { outreachPauseView } from '@/lib/telegramAccountFormat';
import type { TelegramAccount } from '@/types/telegramAccount';

interface OutreachPauseProps {
  account: TelegramAccount;
  now: Date;
}

export function OutreachPauseBadge({ account, now }: OutreachPauseProps): JSX.Element | null {
  const view = outreachPauseView(account, now);
  if (!view) return null;
  return (
    <div className="mt-1.5">
      <span
        data-testid="outreach-pause-badge"
        title={view.title}
        className="inline-block rounded bg-orange-100 px-1.5 py-0.5 text-xs font-medium text-orange-800"
      >
        {view.label}
      </span>
    </div>
  );
}

export function OutreachPauseIcon({ account, now }: OutreachPauseProps): JSX.Element | null {
  const view = outreachPauseView(account, now);
  if (!view) return null;
  return (
    <span
      data-testid="outreach-pause-icon"
      title={view.title}
      aria-label={view.label}
      className="inline-flex text-orange-600"
    >
      <Pause className="h-3.5 w-3.5" />
    </span>
  );
}
